import { forwardRef, type Ref, type SVGProps } from "react";
const IconCreditScoreFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      d="M3.748 15.202c-.548-.316-1.25-.05-1.397.564a14 14 0 0 0-.384 3.27c0 2.724.778 5.266 2.124 7.417a.95.95 0 0 0 1.25.322l3.518-1.82c.581-.3.72-1.07.367-1.62a7.96 7.96 0 0 1-1.234-4.946c.033-.415-.155-.826-.516-1.034zM3.92 11.9c-.271.457-.096 1.037.364 1.302l3.432 1.982c.513.296 1.164.08 1.48-.42a8 8 0 0 1 5.338-3.61c.52-.094.933-.524.933-1.053v-4.02c0-.566-.47-1.023-1.033-.962A14 14 0 0 0 3.92 11.9m13.547-1.561c0 .48.344.886.804 1.024a8.02 8.02 0 0 1 4.6 3.619c.307.523.976.757 1.501.454l3.426-1.978c.453-.261.631-.83.375-1.284a14.02 14.02 0 0 0-9.605-6.897c-.584-.11-1.1.357-1.1.95zm6.5 8.687q0-.175-.007-.349a1.08 1.08 0 0 1 .52-.994l3.775-2.18c.556-.32 1.267-.042 1.401.585.204.95.311 1.937.311 2.948a13.93 13.93 0 0 1-2.115 7.403c-.264.423-.812.552-1.254.321l-3.511-1.83c-.578-.3-.715-1.065-.366-1.614a7.96 7.96 0 0 0 1.246-4.29m-9.831 1.25a1.99 1.99 0 0 1 .729-1.72l5.092-4.122c.886-.718 2.09.37 1.466 1.325l-3.533 5.396a2.05 2.05 0 0 1-1.536.92l-.063.006a1.99 1.99 0 0 1-2.155-1.805"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCreditScoreFilledSVG);
ForwardRef.displayName = "IconCreditScoreFilled";
export { ForwardRef as IconCreditScoreFilled };
